/**
 *
 * Copyright 2020-2025 Splunk Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 */
import { isElement, isInputElement } from '../../types';
import { getParentElement } from '../../utils/index';
export const SensitivityRuleTypesArray = ['mask', 'unmask', 'exclude'];
export const maskText = (text) => text.replaceAll(/\S/gi, '*');
export const getNodePrivacyInfo = (node, sensitivityRules) => ({
    isPasswordInput: isInputElement(node) && node.type === 'password',
    sensitivityRuleType: getSensitivityRuleType(node, sensitivityRules),
});
export const getSensitivityRuleType = (node, sensitivityRules = []) => {
    let sensitivityRuleType = null;
    // Reverse rules so we can match the most specific rule first.
    const reversedSensitivityRules = sensitivityRules.toReversed();
    // Set correct sensitivity rule type if node matches any of the sensitivity rule selectors.
    for (const sensitivityRule of reversedSensitivityRules) {
        const selectorsWithChildrenMatch = createSelectorsWithChildrenMatch(sensitivityRule.selector);
        const isMatch = selectorsWithChildrenMatch.some(isSelectorMatchingNode(node));
        if (isMatch) {
            sensitivityRuleType = sensitivityRule.rule;
            break;
        }
    }
    return sensitivityRuleType;
};
// Create selectors that match the element and all its children. E.g.: ['.masked', '.masked *']
export const createSelectorsWithChildrenMatch = (originalSelector) => originalSelector.split(',').flatMap((selector) => [selector, `${selector} *`]);
const isSelectorMatchingNode = (node) => (selector) => {
    const element = isElement(node) ? node : getParentElement(node);
    if (element === null) {
        return false;
    }
    return element.matches(selector);
};
export const mergePrivacyInfo = (parentPrivacyInfo, currentPrivacyInfo) => {
    const mergedPrivacyInfo = { ...parentPrivacyInfo };
    if (currentPrivacyInfo.isPasswordInput) {
        mergedPrivacyInfo.isPasswordInput = true;
    }
    if (mergedPrivacyInfo.sensitivityRuleType !== 'exclude') {
        mergedPrivacyInfo.sensitivityRuleType = currentPrivacyInfo.sensitivityRuleType;
    }
    return mergedPrivacyInfo;
};
//# sourceMappingURL=utils.js.map